import { render, staticRenderFns, recyclableRender, components } from "./delivery-order-detail.vue?vue&type=template&id=3344e2da&scoped=true&"
var renderjs
import script from "./delivery-order-detail.vue?vue&type=script&lang=js&"
export * from "./delivery-order-detail.vue?vue&type=script&lang=js&"
import style0 from "./delivery-order-detail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./delivery-order-detail.vue?vue&type=style&index=1&id=3344e2da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3344e2da",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/delivery-order-detail/delivery-order-detail.vue"
export default component.exports